export default __webpack_public_path__ + "static/media/Reports.BarChartVertical.e2af1807.svg";